import React from 'react';

import {Button, Dialog, DialogActions, DialogTitle} from '@mui/material';

export default function DeleteModal({ historyId, isOpen, onClose, onDelete }) {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            sx={{
                '& .MuiDialog-paper': {
                    width: '360px',
                    boxSizing: 'border-box',
                    borderRadius: '4px',
                    border: '1px solid',
                    borderColor: 'elevation.outlined',

                }
            }}
        >
            <DialogTitle sx={{ padding: '16px 24px' }}>
                해당 채팅방을 삭제할까요?
            </DialogTitle>
            <DialogActions>
                <Button
                    size='medium'
                    color='secondary'
                    variant='text'
                    onClick={onClose}
                >
                    취소
                </Button>
                <Button
                    size='medium'
                    color='error'
                    variant='contained'
                    disabled={!historyId}
                    onClick={onDelete}
                >
                    삭제
                </Button>
            </DialogActions>
        </Dialog>
    );
}
